// Libraries
import { QueryFunctionContext } from '@tanstack/react-query';
// Services
import { getPerformanceVessel, VesselPerformanceSchema } from '@services/index';
// Types
import { VesselControllerParams } from '@globalTypes/index';

/**
 * Fetches performance data for a specific vessel of a client.
 *
 * @async
 * @function
 * @typedef { imo: number } QueryFunctionContextParams
 * @typedef {[_: any, params: QueryFunctionContextParams]} QueryFunctionContext
 * @param {QueryFunctionContext} queryKey - The context object containing the query key.
 * @param {Array} queryKey
 * @param {number} params.imo - The IMO number of the vessel.
 * @returns {Promise<PerformanceVessel>} - A promise that resolves to the fetched performance vessel data.
 */
export const performanceVesselController = async ({ queryKey }: QueryFunctionContext) => {
  const [_, params] = queryKey;
  const { imo } = params as VesselControllerParams;
  const { data } = await getPerformanceVessel(imo);
  const vesselPerformance = VesselPerformanceSchema.parse(data);

  // This fix is to handle cases where the current contribution factor is close to zero.
  // By setting a minimum threshold for the current contribution factor.
  for (const [, factors] of Object.entries(vesselPerformance.focContributionFactors)) {
    const speedFactorIdx = factors.findIndex((factor) => factor.factor === 'speed');
    const currentFactorIdx = factors.findIndex((factor) => factor.factor === 'current');

    if (Math.abs(factors[currentFactorIdx]?.value) < 0.001 && factors[speedFactorIdx]?.value > 0) {
      const negative = factors[currentFactorIdx]?.value < 0;
      factors[currentFactorIdx].value = negative ? -0.001 : 0.001;
    }
  }

  return vesselPerformance;
};
